import React from 'react'

import { Helmet } from 'react-helmet'

import Header from '../../components/header'
import Footer from '../../components/footer'
import Whatsapp from '../../components/whatsapp'
import './direito-do-trabalho.css'

const DireitoDoTrabalho = (props) => {
  return (
    <div className="direito-do-trabalho-container10">
      <Helmet>
        <title>Direito-do-Trabalho - Adv. Wanderson H Cavalari - Cuiabá</title>
        <meta
          name="description"
          content="Advogado em Cuiabá a mais de 10 anos, defendendo seus direitos com expertise e comprometimento."
        />
        <meta
          property="og:title"
          content="Direito-do-Trabalho - Adv. Wanderson H Cavalari - Cuiabá"
        />
        <meta
          property="og:description"
          content="Advogado em Cuiabá a mais de 10 anos, defendendo seus direitos com expertise e comprometimento."
        />
      </Helmet>
      <div className="direito-do-trabalho-container11">
        <main className="direito-do-trabalho-container12">
          <div className="direito-do-trabalho-container13">
            <Header rootClassName="headerroot-class-name7"></Header>
            <div className="direito-do-trabalho-container14">
              <div className="direito-do-trabalho-frame46">
                <span className="direito-do-trabalho-text100">
                  ÁREA DE ATUAÇÃO
                </span>
                <span className="direito-do-trabalho-text101">Direito do</span>
                <span className="direito-do-trabalho-text102">Trabalho</span>
                <span className="direito-do-trabalho-text103 Content">
                  A área trabalhista é uma área específica do Direito que lida
                  com as relações entre trabalhadores e empregadores e as leis
                  que regem os seus direitos e deveres.
                </span>
              </div>
              <div className="direito-do-trabalho-container15">
                <span className="direito-do-trabalho-text104">
                  <span>Fale Comigo</span>
                </span>
                <span className="direito-do-trabalho-text106 Content">
                  Quer saber mais sobre esta área de atuação? Mande-me uma
                  mensagem para introduzirmos esta questão
                </span>
                <iframe
                  src="https://whc-dun.vercel.app/email"
                  scrolling="no"
                  className="direito-do-trabalho-iframe"
                ></iframe>
              </div>
            </div>
          </div>
          <div className="direito-do-trabalho-container16">
            <div className="direito-do-trabalho-container17">
              <div className="direito-do-trabalho-frame86">
                <div
                  animation="fadeIn"
                  duration="1s"
                  direction="normal"
                  easing="ease-in-out"
                >
                  <div
                    data-thq-animate-on-reveal="true"
                    className="direito-do-trabalho-container18"
                  >
                    <div className="direito-do-trabalho-container19">
                      <span className="direito-do-trabalho-text107">
                        Acidente de Trabalho
                      </span>
                      <span className="direito-do-trabalho-text108">
                        <span>
                          Uma ação de acidente de trabalho é um processo movido
                          por um funcionário contra um empregador em caso de
                          lesão ou dano sofrido durante o desempenho de suas
                          funções no local de trabalho. Essa ação visa obter
                          compensação pelos danos físicos, emocionais e
                          financeiros resultantes do acidente.
                        </span>
                        <br></br>
                        <span>
                          Ao mover uma ação de acidente de trabalho, é
                          importante reunir evidências relevantes, como
                          registros médicos, testemunhas oculares e relatórios
                          de segurança no local de trabalho.
                        </span>
                        <br className="Content"></br>
                      </span>
                    </div>
                    <img
                      alt="image"
                      src="/trab-acidente.jpg"
                      loading="eager"
                      className="direito-do-trabalho-image1"
                    />
                  </div>
                </div>
                <div
                  animation="fadeIn"
                  duration="1s"
                  easing="ease-in-out"
                >
                  <div
                    data-thq-animate-on-reveal="true"
                    className="direito-do-trabalho-container20"
                  >
                    <img
                      alt="image"
                      src="/trab-vinculo.jpg"
                      loading="eager"
                      className="direito-do-trabalho-image2"
                    />
                    <div className="direito-do-trabalho-container21">
                      <span className="direito-do-trabalho-text113">
                        Reconhecimento de Vínculo
                      </span>
                      <span className="direito-do-trabalho-text114">
                        <span>
                          Uma ação de reconhecimento de vínculo trabalhista é um
                          processo judicial movido por um trabalhador para que o
                          empregador reconheça formalmente o vínculo
                          empregatício entre as partes. Isso geralmente ocorre
                          quando há uma relação de trabalho que não foi
                          oficialmente reconhecida pelo empregador, mas que, na
                          prática, caracteriza-se como um contrato de trabalho.
                        </span>
                        <br></br>
                        <span>
                          Existem várias situações em que uma pessoa pode buscar
                          o reconhecimento de vínculo trabalhista, tais como:
                        </span>
                        <br></br>
                        <span>
                          .1. Trabalho informal: Quando o trabalhador exerce
                          suas atividades sem registro formal, mas de forma
                          regular e subordinada a um empregador.
                        </span>
                        <br></br>
                        <span>
                          2. Terceirização irregular: Quando há intermediação de
                          mão de obra por meio de empresas terceirizadas de
                          forma irregular, sem observância das regras
                          trabalhistas.
                        </span>
                        <br></br>
                        <span>
                          3. Trabalho autônomo mascarado: Quando um trabalhador
                          é contratado como autônomo, mas na prática desempenha
                          funções típicas de um empregado, como horários fixos,
                          subordinação e exclusividade.
                        </span>
                        <br></br>
                        <span>
                          4. Estágio irregular: Quando o estágio é utilizado
                          como uma forma de mascarar uma relação de emprego.
                        </span>
                        <br></br>
                        <br className="Content"></br>
                      </span>
                    </div>
                  </div>
                </div>
                <div animation="fadeIn" duration="1000ms">
                  <div
                    data-thq-animate-on-reveal="true"
                    className="direito-do-trabalho-container22"
                  >
                    <div className="direito-do-trabalho-container23">
                      <span className="direito-do-trabalho-text128">
                        Horas extras não recebidas
                      </span>
                      <span className="direito-do-trabalho-text129">
                        <span>
                          Uma ação de horas extras não recebidas é uma medida
                          legal que um trabalhador pode tomar quando não recebe
                          o pagamento adequado pelas horas extras trabalhadas
                          além da jornada normal de trabalho. A Consolidação das
                          Leis do Trabalho (CLT) define as regras para a jornada
                          de trabalho e o pagamento de horas extras.
                        </span>
                        <br></br>
                        <br></br>
                        <span>
                          Para mover uma ação de horas extras não recebidas, o
                          trabalhador geralmente precisa reunir evidências que
                          comprovem que trabalhou além da jornada estabelecida
                          por lei ou pelo contrato de trabalho, e que essas
                          horas não foram devidamente remuneradas. Isso pode
                          incluir registros de ponto, testemunhas, e-mails,
                          registros de acesso ao local de trabalho, entre outros
                          documentos que demonstrem a realização das horas
                          extras.
                        </span>
                        <br></br>
                        <br></br>
                        <span>
                          O objetivo da ação é obter o pagamento das horas
                          extras devidas, com os devidos acréscimos legais, como
                          adicional de horas extras (normalmente 50% a mais que
                          a hora normal), além de reflexos sobre outras verbas
                          trabalhistas, como férias, 13º salário, FGTS, entre
                          outros.
                        </span>
                        <br></br>
                        <br></br>
                        <span>
                          É importante ressaltar que, segundo a legislação, o
                          trabalhador tem até dois anos após o término do
                          contrato de trabalho para ingressar com a ação de
                          horas extras não recebidas. Após esse prazo, o direito
                          de pleitear o pagamento das horas extras pode ser
                          prejudicado pela prescrição.
                        </span>
                        <br></br>
                        <br className="Content"></br>
                      </span>
                    </div>
                    <img
                      alt="image"
                      src="/trab-horas-extras.jpg"
                      loading="eager"
                      className="direito-do-trabalho-image3"
                    />
                  </div>
                </div>
                <div
                  animation="fadeIn"
                  duration="1000ms"
                  easing="ease-in-out"
                >
                  <div
                    data-thq-animate-on-reveal="true"
                    className="direito-do-trabalho-container24"
                  >
                    <img
                      alt="image"
                      src="/trab-justa-causa.jpg"
                      loading="eager"
                      className="direito-do-trabalho-image4"
                    />
                    <div className="direito-do-trabalho-container25">
                      <span className="direito-do-trabalho-text142">
                        Reversão de Justa Causas
                      </span>
                      <span className="direito-do-trabalho-text143">
                        <span>
                          A ação de reversão de justa causa é um processo
                          judicial movido por um trabalhador com o objetivo de
                          reverter a demissão por justa causa aplicada pelo
                          empregador. A justa causa é uma modalidade de rescisão
                          do contrato de trabalho em que o empregador alega que
                          o trabalhador cometeu uma falta grave, conforme
                          previsto na legislação.
                        </span>
                        <br></br>
                        <span>
                          Para reverter uma demissão por justa causa, o
                          trabalhador normalmente precisa provar que a acusação
                          do empregador não procede ou que não houve
                          justificativa suficiente para a aplicação da justa
                          causa. Isso pode incluir demonstrar que não cometeu a
                          falta grave alegada, que não houve dolo (intenção) ou
                          culpa grave, ou que o empregador não seguiu
                          corretamente os procedimentos legais ao aplicar a
                          justa causa.
                        </span>
                        <br></br>
                        <span>
                          Ao mover uma ação de reversão de justa causa, é comum
                          que o trabalhador apresente provas como testemunhos,
                          documentos, registros, e-mails, entre outros, que
                          evidenciem sua versão dos fatos e contestem a
                          justificativa do empregador.
                          <span
                            dangerouslySetInnerHTML={{
                              __html: ' ',
                            }}
                          />
                        </span>
                        <br></br>
                        <span>
                          Caso o tribunal decida favoravelmente ao trabalhador e
                          reverta a demissão por justa causa, o empregador pode
                          ser obrigado a pagar ao trabalhador as verbas
                          rescisórias devidas, como aviso prévio, férias
                          proporcionais, décimo terceiro salário proporcional e
                          saldo de salário, além de possíveis indenizações por
                          danos morais ou materiais, dependendo das
                          circunstâncias do caso.
                        </span>
                        <br></br>
                        <br className="Content"></br>
                      </span>
                    </div>
                  </div>
                </div>
                <div
                  animation="fadeIn"
                  duration="1000ms"
                  easing="ease-in-out"
                >
                  <div
                    data-thq-animate-on-reveal="true"
                    className="direito-do-trabalho-container26"
                  >
                    <div className="direito-do-trabalho-container27">
                      <span className="direito-do-trabalho-text153">
                        Ação de Rescisão Indireta
                      </span>
                      <span className="direito-do-trabalho-text154">
                        <span>
                          A rescisão indireta, também conhecida como &quot;justa
                          causa do empregador&quot; ou &quot;dispensa por culpa
                          do empregador&quot;, é uma medida prevista na
                          legislação trabalhista que permite ao trabalhador
                          encerrar o contrato de trabalho devido a graves
                          irregularidades cometidas pelo empregador,
                          equiparando-se à demissão por justa causa, porém,
                          partindo do funcionário.
                        </span>
                        <br></br>
                        <span>
                          A rescisão indireta pode ser pleiteada quando o
                          empregador descumpre gravemente as obrigações
                          contratuais ou legais, como por exemplo:
                        </span>
                        <br></br>
                        <span>
                          - Atraso no pagamento de salários por período igual ou
                          superior a três meses.
                        </span>
                        <br></br>
                        <span>
                          -
                          <span
                            dangerouslySetInnerHTML={{
                              __html: ' ',
                            }}
                          />
                        </span>
                        <span>Falta de recolhimento do FGTS.</span>
                        <br></br>
                        <span>
                          -
                          <span
                            dangerouslySetInnerHTML={{
                              __html: ' ',
                            }}
                          />
                        </span>
                        <span>
                          Exigência de serviços superiores às forças do
                          empregado, contrárias aos bons costumes ou alheias ao
                          contrato.
                        </span>
                        <br></br>
                        <span>
                          -
                          <span
                            dangerouslySetInnerHTML={{
                              __html: ' ',
                            }}
                          />
                        </span>
                        <span>
                          Situações que coloquem em risco a saúde ou integridade
                          física do trabalhador.
                        </span>
                        <br></br>
                        <span>
                          Se o tribunal reconhecer as irregularidades e conceder
                          a rescisão indireta, o contrato de trabalho é
                          encerrado, e o trabalhador tem direito a receber as
                          verbas rescisórias devidas, tais como aviso prévio,
                          férias proporcionais, décimo terceiro salário
                          proporcional, além de indenizações e multas previstas
                          em lei, conforme o caso.
                        </span>
                        <br></br>
                      </span>
                    </div>
                    <img
                      alt="image"
                      src="/trab-rescisao-indireta.jpg"
                      loading="eager"
                      className="direito-do-trabalho-image5"
                    />
                  </div>
                </div>
                <div className="direito-do-trabalho-container28">
                  <span className="Head direito-do-trabalho-text172">
                    Trabalhistas para Nichos
                  </span>
                  <span className="direito-do-trabalho-text173">
                    <span>
                      Registro em Carteira de Trabalho: Muitas vezes,
                      empregadores domésticos deixam de registrar os
                      funcionários em suas carteiras de trabalho, o que é
                      ilegal.
                    </span>
                    <br></br>
                    <span>
                      Jornada de Trabalho e Horas Extras: As domésticas têm
                      direito a jornadas de trabalho definidas, horas extras
                      remuneradas e descanso semanal remunerado.
                    </span>
                    <br></br>
                    <span>
                      FGTS e INSS: O empregador deve recolher o Fundo de
                      Garantia do Tempo de Serviço (FGTS) e contribuir com o
                      Instituto Nacional do Seguro Social (INSS) do trabalhador
                      doméstico.
                    </span>
                    <br></br>
                    <span>
                      Férias e 13º Salário: Assim como outros trabalhadores, as
                      domésticas têm direito a férias remuneradas e ao 13º
                      salário.
                    </span>
                    <br></br>
                    <span>
                      Adicional Noturno e Insalubridade: Se trabalharem em
                      horário noturno ou em condições insalubres, as domésticas
                      têm direito a adicional de salário.
                    </span>
                    <br></br>
                  </span>
                </div>
                <div
                  animation="fadeIn"
                  duration="1000ms"
                  easing="ease-in-out"
                >
                  <div
                    data-thq-animate-on-reveal="true"
                    className="direito-do-trabalho-container29"
                  >
                    <div className="direito-do-trabalho-container30">
                      <span className="direito-do-trabalho-text184">
                        Domésticas
                      </span>
                      <span className="direito-do-trabalho-text185">
                        <span>
                          Registro em Carteira de Trabalho: Muitas vezes,
                          empregadores domésticos deixam de registrar os
                          funcionários em suas carteiras de trabalho, o que é
                          ilegal.
                        </span>
                        <br></br>
                        <span>
                          Jornada de Trabalho e Horas Extras: As domésticas têm
                          direito a jornadas de trabalho definidas, horas extras
                          remuneradas e descanso semanal remunerado.
                        </span>
                        <br></br>
                        <span>
                          FGTS e INSS: O empregador deve recolher o Fundo de
                          Garantia do Tempo de Serviço (FGTS) e contribuir com o
                          Instituto Nacional do Seguro Social (INSS) do
                          trabalhador doméstico.
                        </span>
                        <br></br>
                        <span>
                          Férias e 13º Salário: Assim como outros trabalhadores,
                          as domésticas têm direito a férias remuneradas e ao
                          13º salário.
                        </span>
                        <br></br>
                        <span>
                          Adicional Noturno e Insalubridade: Se trabalharem em
                          horário noturno ou em condições insalubres, as
                          domésticas têm direito a adicional de salário.
                        </span>
                        <br></br>
                      </span>
                    </div>
                    <img
                      alt="image"
                      src="/trab-domesticas.jpg"
                      loading="eager"
                      className="section_image"
                    />
                  </div>
                </div>
                <div
                  animation="fadeIn"
                  duration="1000ms"
                  easing="ease-in-out"
                >
                  <div
                    data-thq-animate-on-reveal="true"
                    className="direito-do-trabalho-container31"
                  >
                    <div className="direito-do-trabalho-container32">
                      <span className="direito-do-trabalho-text196">
                        Vigilantes
                      </span>
                      <span className="direito-do-trabalho-text197">
                        <span>
                          Adicional de Periculosidade: Vigilantes que exercem
                          atividades de risco têm direito ao adicional de
                          periculosidade.
                        </span>
                        <br></br>
                        <span>
                          Jornada de Trabalho: Deve-se respeitar a jornada de
                          trabalho e horas extras de acordo com a legislação
                          trabalhista.
                        </span>
                        <br></br>
                        <span>
                          Intervalo Intrajornada: Garantir o intervalo
                          intrajornada de acordo com a jornada de trabalho
                          estabelecida.
                        </span>
                        <br></br>
                        <span>
                          Equipamentos de Proteção Individual (EPIs): O
                          empregador é responsável por fornecer EPIs adequados e
                          em bom estado de conservação.
                        </span>
                        <br></br>
                      </span>
                    </div>
                    <img
                      alt="image"
                      src="/trab-vigilantes.jpg"
                      loading="eager"
                      className="section_image"
                    />
                  </div>
                </div>
                <div
                  animation="fadeIn"
                  duration="1000ms"
                  easing="ease-in-out"
                >
                  <div
                    data-thq-animate-on-reveal="true"
                    className="direito-do-trabalho-container33"
                  >
                    <div className="direito-do-trabalho-container34">
                      <span className="direito-do-trabalho-text206">
                        Caminhoneiros
                      </span>
                      <span className="direito-do-trabalho-text207">
                        <span>
                          Controle de Jornada: Garantir que os caminhoneiros
                          tenham controle adequado de sua jornada de trabalho,
                          incluindo períodos de descanso e limites de horas
                          dirigidas, conforme estabelecido pela legislação.
                        </span>
                        <br></br>
                        <span>
                          Horas Extras e Diárias: O direito às horas extras e
                          diárias de trabalho, especialmente em viagens longas,
                          deve ser assegurado.
                        </span>
                        <br></br>
                        <span>
                          Condições de Trabalho: Garantir condições de trabalho
                          seguras e saudáveis, incluindo o direito a pausas para
                          descanso e alimentação.
                        </span>
                        <br></br>
                        <span>
                          Reconhecimento do Vínculo Empregatício: Em casos de
                          contratação como autônomo, mas com características de
                          vínculo empregatício, pode-se buscar o reconhecimento
                          desse vínculo e os direitos trabalhistas associados.
                        </span>
                        <br></br>
                        <br></br>
                      </span>
                    </div>
                    <img
                      alt="image"
                      src="/trab-caminhoneiros.jpg"
                      loading="eager"
                      className="section_image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer rootClassName="footerroot-class-name2"></Footer>
          <Whatsapp></Whatsapp>
        </main>
      </div>
    </div>
  )
}

export default DireitoDoTrabalho
